
	// @ts-nocheck  (визард собирается, а юарм - нет, и наоборот. Надо что-то делать)
	export default {
		name: 'flagVisible',
		props: {},
		data () {
			let _this = this,
				observer = new IntersectionObserver(function(entries, observer) { // PIRS2018-5581 долгий рендер сравнения.
					if (entries[0].intersectionRatio) {
						// entries[0].boundingClientRect.top < entries[0].rootBounds.bottom
						_this.updateVisibility(entries, observer);
					}
				}, { root: null, rootMargin: '0px', threshold: 1 });

			return {
				observer: observer,
				inWindowVisibility: false
			}
		},
		computed: {},
		components: {},
		methods: {
			updateVisibility: function(entries, observer) {
				this.inWindowVisibility = true;
				this.$emit('windowVisibility', this, entries, observer);
			}
		},
		mounted () {
			if (this.$el) {
				// PIRS2018-5581 объект для наблюдения входа в область видимости браузера.
				this.observer.observe(this.$el);
			}
		}
	}
